module.exports = __webpack_public_path__ + "static/media/redchip_plus.3f67f8c1.svg";